import jQuery from 'jquery';

/**
 * Misc. 1 liners
 *
 * @export
 */
export default function() {
  const $ = jQuery;
  $('.js-element').removeClass('is-hidden');
}


// WEBPACK FOOTER //
// ./assets/src/js/components/general.js